import axiosInstance from "@/common/axiosInstance";
import apiCall from "./apiCall";
import {
  otherArray,
  otherCostArray,
  otherEvidenceFileIdArray,
} from "@/utils/arrayState";
import { TCountryCode } from "countries-list";

type OtherIndex = (typeof otherArray)[number];
type OtherCostIndex = (typeof otherCostArray)[number];
type OtherEvidenceFileIdIndex = (typeof otherEvidenceFileIdArray)[number];

export type InvoiceInspectingCo = {
  [other in OtherIndex]: string | null; // other{1-10}
} & {
  [otherCost in OtherCostIndex]: number | null; // otherFee{1-10}
} & {
  [otherEvidenceFileId in OtherEvidenceFileIdIndex]: string | null; // otherEvidence{1-10}Id
} & {
  invoiceNumber: string;
  sequenceID: string;
  inspectorsId: string;
  inspectorsName: string;
  vesselId: string;
  shipName: string;
  invoiceDate: string;
  inspectionDate: string;
  country: TCountryCode;
  port: string;
  jobDescription: string;
  costInspection: number;
  awaitingDays: number;
  awaitingDaysCost: number;
  subTotalCost: number;
  totalAmount: number;
  currency: string;
  invoiceStatus: number;
  paymentStatus: number;
  note: string | null;
  paymentDate: string | null;
  paymentDownloadId: string | null;
  invoiceDownloadId: string;
  inspectionResultId: string;
  sireType: string;
  totalAmountIDR: number | null;
  created: string;
  id: string;
};

const getListInvoiceInspector = async (param: any) => {
    const query = `?search=${param.search}&paymentStatus=${param.paymentStatus}&invoiceStatus=${param.invoiceStatus}&status=${param.status}&market=${param.market}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/InvoiceInspectors/GetAllInspectorInvoices${query}`;
    return apiCall('get', URL);
};

const getListInvoiceInspectorById = async (param: any) => {
    const query = `?search=${param.search}&id=${param.id}&paymentStatus=${param.paymentStatus}&invoiceStatus=${param.invoiceStatus}&status=${param.status}&market=${param.market}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/InvoiceInspectors/GetAllInspectorInvoiceByInspectorId${query}`;
    return apiCall('get', URL);
};

const getInvoiceInspectorById = async (id: string) => {
  const URL = `/InvoiceInspectors/GetInspectorInvoiceById/${id}`;
  return apiCall("get", URL);
};

const putInvoiceInspector = async (data: any) => {
  const URL = "/InvoiceInspectors/Update";
  return apiCall("post", URL, data);
};

const postInvoiceInspector = async (data: any) => {
  const URL = "/InvoiceInspectors/Create";

  try {
    const response = await axiosInstance.post<any>(URL, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (err: any) {
    const obj = {
      status: err?.response?.status,
      message: err?.response?.data?.message,
    };
    return obj;
  }
};

const deleteInvoiceInspector = async (obj: any) => {
  const URL = "/InvoiceInspectors/Delete";
  return apiCall("post", URL, obj);
};

const updateInvoiceStatusInspector = async (data: any) => {
  const URL = "/InvoiceInspectors/UpdateInvoiceStatus";
  return apiCall("post", URL, data);
};

const updateConfirmPaymentInspector = async (data: any) => {
  const URL = "/InvoiceInspectors/ConfirmPayment";

  try {
    const response = await axiosInstance.post<any>(URL, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (err: any) {
    const obj = {
      status: err?.response?.status,
      message: err?.response?.data?.message,
    };
    return obj;
  }
};

const updatePaymentStatusInspector = async (data: any) => {
  const URL = "/InvoiceInspectors/UpdatePaymentStatus";

  try {
    const response = await axiosInstance.post<any>(URL, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (err: any) {
    const obj = {
      status: err?.response?.status,
      message: err?.response?.data?.message,
    };
    return obj;
  }
};

const updatePaymentStatusInspectorOnlyAxios = async (data: any) => {
  const URL = "/InvoiceInspectors/UpdatePaymentStatus";

  return await axiosInstance.post<any>(URL, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export {
  deleteInvoiceInspector,
  postInvoiceInspector,
  putInvoiceInspector,
  getInvoiceInspectorById,
  getListInvoiceInspector,
  getListInvoiceInspectorById,
  updateInvoiceStatusInspector,
  updateConfirmPaymentInspector,
  updatePaymentStatusInspector,
  updatePaymentStatusInspectorOnlyAxios,
};
